<template>
  <div>
    <v-row justify="center" align="center" class="text-center">
      <v-col cols="12" md="8" v-if="getFullName">
        <p class="headline font-weight-bold">
          {{ $t("message.title") }}<br><br>
          {{ $store.state.survey.name }} 
          <span v-if="$store.state.survey.desc">-</span> 
          {{ $store.state.survey.desc }}
        </p>
        <p class="title">{{$t("message.welcome")}} {{ getFullName }}</p>
        <p class="body-1" v-if="$store.state.questionPaths.length > 0">
          {{$t("message.index_you_have")}}
          {{$store.state.unansweredQuestionCount}} <!--/ {{allSurveyQuestions.length}}-->
          {{$t("message.index_questions")}}
        </p>
        <div v-else>
          <p class="body-1" v-html="$t('message.questionsComplete')">
          </p>
          <v-btn v-on:click="reviewAll" large color="primary" :to="`/survey/${$route.params.questions}/${allSurveyQuestions[0]}/`">{{$t("message.reviewAll")}}</v-btn>
        </div>
        <v-btn v-if="$store.state.questionPaths.length > 0" v-on:click="reviewUnanswered" large color="success mx-2" :to="`/survey/${$route.params.questions}/${$store.state.questionPaths[0]}/`">{{$t("message.unanswered")}}</v-btn>
      </v-col>
      <v-col v-else> 
        <p class="headline font-weight-bold" v-html="$t('message.responseNotFound')">
          
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["allSurveyQuestions", "getFullName"])
  },
  mounted: function() {
    // this does the initial retrieval of the response based on the ID hash in the url, which is $route.params.questions
    this.$store.dispatch('bindResponseRef', this.$route.params.questions)
  },
  methods: {
    reviewUnanswered() {
      this.$store.commit('setReviewType')
      this.$router.push(`/survey/${this.$route.params.questions}/${this.$store.state.questionPaths[0]}/`)
    },
    reviewAll() {
      this.$store.commit('setReviewType', 'all')
      this.$router.push(`/survey/${this.$route.params.questions}/${this.allSurveyQuestions[0]}/`)
    }
  }
};
</script>